import { render } from "./news-slider-com.vue?vue&type=template&id=4042d5d2&scoped=true"
import script from "./news-slider-com.vue?vue&type=script&lang=js"
export * from "./news-slider-com.vue?vue&type=script&lang=js"

import "./news-slider-com.vue?vue&type=style&index=0&id=4042d5d2&scoped=true&lang=css"

import exportComponent from "/Users/achinthaprabasha/Desktop/work/yathra/yathra-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4042d5d2"]])

export default __exports__